/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { SlideToggle, Tooltip } from '../../../canvasComponents/index';
import CustomToggleV2SettingsForm from './CustomToggleV2.settingsForm';

const CustomToggleV2 = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const { value } = this.state || null;
    const { component } = this.props || null;
    const { defaultValue } = component || null;
    if (value === null && defaultValue !== null) {
      this.setValue(defaultValue);
    }
  }

  setValue = (v) => {
    const { onChange, component: { trueValue, option1, option2, hasTypelist, useReviewLabel, label, reviewLabel } } = this.props || null;
    const typelist = hasTypelist ? { true: trueValue === 'option1' ? option1 : option2, false: trueValue !== 'option1' ? option1 : option2 } : null;
    const newLabel = useReviewLabel ? reviewLabel : label;
    v = typelist ? { value: v, review: { label: newLabel, typelist } } : { value: v, review: { label: newLabel } };
    this.setState({ value: v }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  render() {
    const { value } = this.state;
    const { component, disabled } = this.props || null;
    const { trueValue, option1, option2, hideCustomLabel, label, tooltip } = component || null;
    const trueV = trueValue === 'option1' ? option1 : option2;
    const falseV = trueValue !== 'option1' ? option1 : option2;
    return (
      option1 && option2
      && trueValue
        ? (
          <>
            {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                {label}
              </label>
              {tooltip !== '' && (
              <Tooltip id="toggleV2_tooltip" primary>
                {tooltip}
              </Tooltip>
              )}
            </div>
            )}
            <SlideToggle
              id="slide_toggleV2"
              disabled={disabled}
              value={value !== null && value.value ? trueV : falseV}
              option1={option1}
              option2={option2}
              onToggle={() => this.setValue(!value?.value)}
              primary
            />
          </>
        ) : null
    );
  }
};

export default class ToggleCompV2 extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Toggle V2',
      icon: 'check-square',
      group: 'basic',
      documentation: '',
      schema: ToggleCompV2.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customtogglev2',
      },
      extend,
    );
  }

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */

  static editForm = CustomToggleV2SettingsForm;

  attachReact(element) {
    let instance;
    ReactDOM.render(
      <CustomToggleV2
        ref={(refer) => {
          instance = refer;
        }}
        disabled={this._disabled}
        component={this.component} // These are the component settings if you want to use them to render the component.
        value={this.dataValue || this.dataForSetting} // The starting value of the component.
        onChange={this.updateValue} // The onChange event to call when the value changes.
      />,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
